import { render, staticRenderFns } from "./AddBookmarkDialog.vue?vue&type=template&id=6f2233e9&scoped=true"
import script from "./AddBookmarkDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddBookmarkDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddBookmarkDialog.vue?vue&type=style&index=0&id=6f2233e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2233e9",
  null
  
)

export default component.exports